import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const EtpStpChemicals: React.FC = () => {
  return (
    <>
      <PageHeader customClass='bg-breadcrumb-sanyola' title="ETP/STP Chemicals – SANYOL® WT Series" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">ETP/STP Chemicals – SANYOL® WT Series</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Effluent and Sewage Treatment Plants (ETP/STP) require effective and responsive chemical treatment to manage suspended solids, organic load, sludge handling, and disinfection. At Wasser Technochem (I) Ltd., our SANYOL® WT range of chemicals is specially designed to optimize performance at every stage of the treatment process — from coagulation to final discharge or reuse.</p>
              <p>We serve textile, food, pharma, automobile, and municipal sectors with high-performing treatment aids that reduce environmental impact and ensure compliance with CPCB and local discharge norms.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-industry text-primary me-2"></i>Industrial ETPs (textile, distilleries, chemical, pharma)</p>
              <p><i className="fa fa-city text-primary me-2"></i>Municipal STPs (conventional, MBBR, MBR, SBR)</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Sludge dewatering units</p>
              <p><i className="fa fa-recycle text-primary me-2"></i>ZLD systems (as pre-treatment)</p>
              <p><i className="fa fa-water text-primary me-2"></i>Tertiary treatment & polishing units for reuse</p>

              <h3 className="mb-4">Product Range (SANYOL® WT)</h3>
              
              <h4 className="mb-3"><i className="fa fa-flask text-primary me-2"></i>Coagulants:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Inorganic (Alum, PAC) and organic (polyamine) options</p>

              <h4 className="mb-3"><i className="fa fa-layer-group text-primary me-2"></i>Flocculants:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Anionic, cationic, and non-ionic polyelectrolytes (powder/liquid)</p>

              <h4 className="mb-3"><i className="fa fa-cloud text-primary me-2"></i>Defoamers:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Silicone and non-silicone formulations</p>

              <h4 className="mb-3"><i className="fa fa-balance-scale text-primary me-2"></i>pH Adjustment Agents:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Caustic soda, lime, sodium bicarbonate, etc.</p>

              <h4 className="mb-3"><i className="fa fa-compress text-primary me-2"></i>Sludge Dewatering Aids:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Improves filter press and decanter performance</p>

              <h4 className="mb-3"><i className="fa fa-shield-alt text-primary me-2"></i>Disinfectants & Odor Control:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Chlorine, hydrogen peroxide, and stabilized oxidants</p>

              <h3 className="mb-4">Features & Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Improves clarity, BOD/COD reduction, and sludge settling</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Increases efficiency of primary and secondary treatments</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduces chemical consumption via optimized dosing</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Enables treated water reuse or safe discharge</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Supports consistent compliance with environmental norms</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Over 25 years of hands-on experience in ETP/STP operations</p>
              <p><i className="fa fa-star text-warning me-2"></i>Jar testing and polymer selection services</p>
              <p><i className="fa fa-star text-warning me-2"></i>Custom chemical blends for complex industrial effluents</p>
              <p><i className="fa fa-star text-warning me-2"></i>Continuous supply support for O&M sites and remote plants</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Integrated programs for wastewater recycling and ZLD</p>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default EtpStpChemicals;
